module.exports = __webpack_public_path__ + "static/media/ja-JP.e22c75b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/ja-JP.png
// module id = 950
// module chunks = 0